import { WhoDrugDictionaryControllerApi } from "@/lib/api/generated/casedb";
import { catalogApiClient } from "../../shared/services/catalogApiClient";

export async function whoDrugReleases() {
  return (await (await catalogApiClient(WhoDrugDictionaryControllerApi)).whoDrugReleases()).data;
}
export async function searchWhoDrug(releaseId: number, query: string, offset: number, signal: AbortSignal, country = "", mah = "") {
  return (await (await catalogApiClient(WhoDrugDictionaryControllerApi)).searchWhoDrug(releaseId, query, offset, 20, country || undefined, mah || undefined,
    { signal, headers: { "X-Skip-Loading": "true" } })).data;
}

export async function whoDrugFilterOptions(releaseId: number, signal: AbortSignal) {
  return (await (await catalogApiClient(WhoDrugDictionaryControllerApi)).whoDrugFilterOptions(releaseId,
    { signal, headers: { "X-Skip-Loading": "true" } })).data;
}
